/**
 * DLP signal API — POSTs from the frontend DlpProtection layer to
 * /audit/dlp-event so Compliance can correlate client-side extraction
 * attempts with the server-side read audit.
 *
 * Charter §6: never include regulated field values in `extra`. The
 * payload is captured into audit_log.notes and reviewed by humans;
 * keep it to event metadata only (key combo, blur duration, etc.).
 */
import { api } from './client';

export type DlpEventType =
  | 'print_attempt'
  | 'print_completed'
  | 'blur_on_pii_page'
  | 'context_menu_blocked'
  | 'copy_blocked'
  | 'save_blocked';

export interface DlpEventBody {
  event_type: DlpEventType;
  page_path?: string;
  entity_type?: string;
  entity_id?: string;
  extra?: Record<string, unknown>;
}

export const dlpApi = {
  /**
   * Fire-and-forget signal. Failures are swallowed — the user-facing
   * deterrent (toast / modal / watermark) does not depend on the
   * server having received the report; the report is for audit, not
   * UX correctness.
   */
  recordEvent: (body: DlpEventBody): void => {
    api.post<void>('/audit/dlp-event', body).catch(() => {
      // Intentional: audit reliability is a server concern. If the
      // POST failed (offline, 401, 5xx), we don't surface it.
    });
  },
};
